/**
 * @Class: components
 * @Module: components
 * @Description:  组件 -管理器
 * @Version: 1.0.0
 ---- Created by "Sitdown.liu<731225377@qq.com>" on "2019/10/23 16:28" ---*/
import com_social_sharing from '@/components/com-social-sharing.vue';
import com_banner_img from '@/components/com-banner-img.vue';
import com_pages_title from '@/components/com-pages-title.vue';
import com_pages_sub_title from '@/components/com-pages-sub-title.vue';
import com_product_mobile from '@/components/com-product-mobile.vue';
import com_product_pc from '@/components/com-product-pc.vue';
import com_footer from '@/components/com-footer.vue';
import com_home_banner from '@/components/com-home-banner.vue';


const Components = (Vue) => {
  if (Components.installed) return;

  Vue.component("com-social-sharing", com_social_sharing);
  Vue.component("com-banner-img", com_banner_img);
  Vue.component("com-pages-title", com_pages_title);
  Vue.component("com-pages-sub-title", com_pages_sub_title);
  Vue.component("com-product-mobile", com_product_mobile);
  Vue.component("com-product-pc", com_product_pc);
  Vue.component("com-footer", com_footer);
  Vue.component("com-home-banner", com_home_banner);
};


export default Components;



// WEBPACK FOOTER //
// ./src/components/components.js